// =========================================================================
// Which create actions the palette offers, and how the typed query narrows
// them. Pure — the palette runs cmdk with `shouldFilter={false}`, so this IS
// the narrowing (COMMAND_SHOULDFILTER_FILTERING).
// Split out of CommandPalette.tsx (module-size).
// =========================================================================

import {
  CREATE_ACTIONS,
  SUPPORT_TICKET_ACTION,
  type CreateAction,
  type CreateActionGateContext,
} from "@/components/ui/navigation/enhanced-quick-actions/create-actions";

/** Suggestions shown before anything is typed. */
export const MAX_UNFILTERED_CREATE_ACTIONS = 5;

/**
 * The create catalog this user may see. Clients get exactly one action
 * (CLIENT_USER_ACCESS_SCOPE), and only when ticket creation is enabled;
 * everyone else gets the shared catalog run through its own gates, so the
 * palette can never offer an action the quick-create menu would not.
 */
export function resolveCreateActions(
  gateContext: CreateActionGateContext,
  clientRestricted: boolean,
): CreateAction[] {
  if (clientRestricted) {
    return gateContext.isFeatureEnabled("canCreateTickets") ? [SUPPORT_TICKET_ACTION] : [];
  }
  return CREATE_ACTIONS.filter((action) => action.gate(gateContext));
}

/** Narrow the create list by the typed query (label or description). */
export function filterCreateActions(actions: CreateAction[], trimmedQuery: string): CreateAction[] {
  if (!trimmedQuery) return actions.slice(0, MAX_UNFILTERED_CREATE_ACTIONS);
  const needle = trimmedQuery.toLowerCase();
  return actions.filter(
    (action) =>
      action.label.toLowerCase().includes(needle) ||
      action.desc.toLowerCase().includes(needle),
  );
}
